Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    API = {
        getNewNavbar: function(options) {
            return new Entities.Navbar(options);
        },
        getNavbarPhotoLocations: function(options) {
            var photoLocations = new Entities.NavbarPhotoLocations([], options);
            photoLocations.goTo(1);
            return photoLocations;
        }
    };
    Entities.Navbar = Entities.Model.extend({
        defaults: {
            // Customization Options
            search: false,
            categories: false,
            categoriesSelectOne: false,
            categoryAlbums: [],
            categoryFilters: [],
            seasons: false,
            personalized: false,
            location: false,
            sort: false,
            sortRecent: false,
            sortPopular: false,
            sortPrice: false,
            // Navbar Attributes
            widgetType: '',
            sort_by: 'sort_default',
            mobile_sort_by: 'sort_default',
            location_active: false,
            map_viewport: '',
            personalization_platform: '',
            personalization_access_token: '',
            personalization_access_token_secret: '',
            personalization_social_id: '',
            personalization_longitude: '',
            personalization_latitude: '',
            // Extra Info
            current_account: {},
            current_album: {}
        }
    });

    Entities.NavbarPhotoLocation = Entities.Model.extend({});
    Entities.NavbarPhotoLocations = Entities.PaginatedCollection.extend({
        model: Entities.NavbarPhotoLocation,
        initialize: function(models, options) {
            this.url = _.result(options, 'url');
            this.paginator_core.url = this.url;
            this.perPage = 100;
            this.dataType = 'approved';
        },
        server_api: {
            page: function() {
                return this.currentPage;
            },
            ipp: function() {
                return this.perPage;
            },
            data_type: function() {
                return this.dataType;
            }
        },
        parse: function(e) {
            var total_count;
            if (e.data.length > 0) {
                total_count = e.data[0].total_count;
            } else {
                total_count = 0;
            }
            _.pluck(e.data, "total_count");
            this.currentPage = e.page;
            this.totalRecords = total_count;
            this.perPage = e.ipp;
            if (e.next) {
                this.totalPages++;
            }
            return e.data;
        }
    });

    App.reqres.setHandler('get:new:navbar:model', function(options) {
        return API.getNewNavbar(options);
    });

    App.reqres.setHandlers({
        'get:new:navbar:model': function(options) {
            return API.getNewNavbar(options);
        },
        'get:navbar:photo:locations': function() {
            return API.getNavbarPhotoLocations({
                url: function() {
                    return App.request('get:location:url');
                }
            });
        }
    });

});